import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Lista de idiomas suportados
export const supportedLanguages = {
  pt: { nativeName: 'Português', flag: '🇧🇷' },
  en: { nativeName: 'English', flag: '🇺🇸' },
  es: { nativeName: 'Español', flag: '🇪🇸' },
};

i18n
  // Carrega traduções usando http (em produção, carrega de public/locales)
  .use(Backend)
  // Detecta idioma do usuário
  .use(LanguageDetector)
  // Passa a instância i18n para react-i18next
  .use(initReactI18next)
  // Inicializa i18next
  .init({
    fallbackLng: 'pt', // Idioma padrão
    debug: false, // Ativar apenas em desenvolvimento se necessário
    
    // Idiomas disponíveis
    supportedLngs: ['pt', 'en', 'es'],
    
    // Interpolação
    interpolation: {
      escapeValue: false, // React já faz escape
    },
    
    // Backend options
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    
    // Detecção de idioma
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    // React specific
    react: {
      useSuspense: true,
    },
  });

export default i18n;
